(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header   = document.getElementById('header');
  var toggle   = document.querySelector('[data-menu-toggle]');
  var menu     = document.getElementById('MobileMenu');
  var backdrop = document.querySelector('.mobile-menu-backdrop');
  if (!toggle || !menu || !backdrop) return;

  function setHeaderH() { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); }
  setHeaderH(); window.addEventListener('resize', setHeaderH);

  function open() {
    setHeaderH();
    menu.hidden = false; backdrop.hidden = false;
    requestAnimationFrame(function () { menu.classList.add('is-open'); backdrop.classList.add('is-open'); });
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    menu.classList.remove('is-open'); backdrop.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { menu.hidden = true; backdrop.hidden = true; }, 300);
  }
  toggle.addEventListener('click', function () { toggle.getAttribute('aria-expanded') === 'true' ? close() : open(); });
  backdrop.addEventListener('click', close);
  menu.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') close(); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-cart-toggle]')) close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
/* 09-20: 고른 변형만 src를 붙여 다운로드 — 숨긴 쪽 1.4MB 이중 로드 제거 */
(function () {
  var vars = document.querySelectorAll('[data-hero-variant]');
  if (!vars.length) return;
  var pick = Math.random() < 0.5 ? 'a' : 'b';
  vars.forEach(function (el) {
    var on = el.getAttribute('data-hero-variant') === pick;
    el.hidden = !on;
    if (on) { var img = el.querySelector('img'); img.src = img.dataset.src; img.fetchPriority = 'high'; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  var z=document.querySelector('[data-pdp-zoom]'); if(!z) return;
  var img=z.querySelector('img');
  document.querySelectorAll('[data-zoom-src]').forEach(function(el){
    el.addEventListener('click',function(){ img.src=el.getAttribute('data-zoom-src'); z.hidden=false; document.body.style.overflow='hidden'; });
  });
  function close(){ z.hidden=true; document.body.style.overflow=''; }
  z.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();
})();
